import { useCustom } from '@refinedev/core';
import { Badge, Card, Col, Row, Space, Statistic, Tag, Typography } from 'antd';
import { EyeOutlined, ThunderboltOutlined } from '@ant-design/icons';
import type { LiveStatsOut, ThroughputStatsOut } from '@/api/generated/schemas';

export const LiveActivityCard = () => {
  const { query: liveQuery } = useCustom<LiveStatsOut>({
    url: 'progress/sessions/stats/live',
    method: 'get',
    queryOptions: { refetchInterval: 30000 },
  });
  const { query: throughputQuery } = useCustom<ThroughputStatsOut>({
    url: 'progress/sessions/stats/live/throughput',
    method: 'get',
    queryOptions: { refetchInterval: 30000 },
  });

  const live = liveQuery.data?.data;
  const throughput = throughputQuery.data?.data;
  const throughputMinutes = throughput
    ? Math.round(throughput.total_delta_seconds / 60)
    : 0;

  const VARIANT_COLORS: Record<string, string> = {
    full: 'green',
    preview: 'blue',
    demo: 'gold',
  };
  const KIND_COLORS: Record<string, string> = {
    ebook: 'purple',
    audio: 'orange',
  };

  return (
    <Card
      loading={liveQuery.isLoading}
      title={
        <Space>
          <Badge status="processing" />
          Aktywność na żywo
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            (okno {live?.window_minutes ?? 15} min)
          </Typography.Text>
        </Space>
      }
    >
      <Row gutter={[24, 16]}>
        <Col xs={12} sm={8}>
          <Statistic
            title="Aktywne sesje"
            value={live?.active_sessions ?? 0}
            valueStyle={{ color: '#1677ff' }}
          />
        </Col>
        <Col xs={12} sm={8}>
          <Statistic
            title="Aktywni czytelnicy"
            value={live?.active_readers ?? 0}
            prefix={<EyeOutlined />}
          />
        </Col>
        <Col xs={24} sm={8}>
          <Statistic
            title="Przepustowość"
            value={throughputMinutes}
            prefix={<ThunderboltOutlined />}
            suffix={
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                min / {throughput?.window_minutes ?? 60}min okno
              </Typography.Text>
            }
          />
        </Col>
      </Row>

      {live && (
        <Space style={{ marginTop: 12 }} wrap>
          {Object.entries(live.by_variant).map(([variant, stats]) => (
            <Tag key={variant} color={VARIANT_COLORS[variant] ?? 'default'}>
              {variant}: {stats.active_sessions} sesji
            </Tag>
          ))}
          {Object.entries(live.by_kind).map(([kind, stats]) => (
            <Tag key={kind} color={KIND_COLORS[kind] ?? 'default'}>
              {kind}: {stats.active_sessions} sesji
            </Tag>
          ))}
        </Space>
      )}
    </Card>
  );
};
